import React from 'react';

import {
  Icon,
} from 'web-components';

import * as S from './styled';
import { ButtonProps } from './styled';

type Props = React.ComponentProps<'button'> & React.ComponentProps<'a'> & ButtonProps

/**
 * Button
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
const Button = React.forwardRef<HTMLButtonElement, Props>((props: ButtonProps, ref) => {
  const {
    isDisabled = false,
    isSelected = false,
    isLoading = false,
    children = null,
    className = '',
    inline = false,
    type = 'button',
    icon = '',
    iconSize = 'default',
    iconColor = 'inherit',
    spacing = 'default',
    appearance = 'default',
    onClick = () => { },
  } = props;
  return (
    <S.Button
      {...props}
      ref={ref}
      type={type}
      spacing={spacing}
      className={className}
      appearance={appearance}
      onClick={onClick}
      inline={inline}
      isSelected={isSelected}
      disabled={isDisabled}
    >
      {!!icon && (
        <Icon
          type={icon}
          size={iconSize}
          color={iconColor}
        />
      )}
      {children && (<span>{children}</span>)}
      {isLoading && (
        <Icon
          type="fa fa-spinner fa-spin"
          color="inherit"
        />
      )}
    </S.Button>
  );
});

export default Button;
